import type {
  CourseMenuParams,
  CourseMenuResponse
} from '@/models/interface/courseMenu';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

const baseUrl: string = import.meta.env.VITE_FUNDAY_API_URL;

/**
 * 課程選單列表 API 服務
 */
export class CourseMenuService extends ApiFactory {
  constructor() {
    super(`${baseUrl}`);
  }

  /**
   * 取得 課程選單列表 (依據學習目標篩選)
   * @param typeId - 學習功能編號
   * @param params - 請求參數
   * @remarks 學習功能編號:
   * - 1: Speaking, 2: Writing, 3: Reading, 4: Streaming
   */
  getCourseFeatureMenu(
    typeId: number,
    params: CourseMenuParams
  ): Promise<ApiDataResponse<CourseMenuResponse[]>> {
    return super.get(`v1/Menu/GetFeatureMenu/${typeId}`, params);
  }
}
